/**
 * TODO: this should go to the hooks package as a separate hook
 */
import { useEffect, useRef, useState } from 'react';
export const useOnScreen = (ref, rootMargin = '0px') => {
    // State and setter for storing whether element is visible
    const [isVisible, setIsVisible] = useState(false);
    const [isTopAbove, setIsTopAbove] = useState(false);
    const [isAbove, setIsAbove] = useState(false);
    const [isBelow, setIsBelow] = useState(false);
    const isScrolling = useRef(false);
    const [isMounted, setIsMounted] = useState(true);
    useEffect(() => {
        let observer;
        let interval;
        const scrollEventHandler = () => {
            isScrolling.current = true;
        };
        if (isMounted) {
            observer = new window.IntersectionObserver(([entry]) => {
                setIsTopAbove(entry.boundingClientRect.top < 0);
                setIsVisible(entry.isIntersecting);
                setIsAbove(!entry.isIntersecting && entry.boundingClientRect.top > 0);
                setIsBelow(!entry.isIntersecting && entry.boundingClientRect.top <= 0);
            }, {
                root: null,
                threshold: 0,
                rootMargin,
            });
            interval = setInterval(() => {
                if (isScrolling.current && ref.current) {
                    isScrolling.current = false;
                    const offset = ref.current.getBoundingClientRect();
                    setIsTopAbove(offset.top < 0);
                }
            }, 300);
            ref.current && observer.observe(ref.current);
            window.addEventListener('scroll', scrollEventHandler);
        }
        return () => {
            setIsMounted(false);
            ref.current && observer.unobserve(ref.current);
            window.removeEventListener('scroll', scrollEventHandler);
            clearInterval(interval);
        };
    }, []); // Empty array ensures that effect is only run on mount and unmount
    return { isVisible, isTopAbove, isAbove, isBelow };
};
//# sourceMappingURL=useOnScreen.js.map